import { render, staticRenderFns } from "./PaymentDeveloper.vue?vue&type=template&id=aa4bf8a2&"
import script from "./PaymentDeveloper.vue?vue&type=script&lang=js&"
export * from "./PaymentDeveloper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports